export interface ResolvedActiveSummaryVersion {
  defaultSelectedId: string | undefined;
  activeLlmOutputId: string | null;
  latestLlmOutputId: string | undefined;
  showLatestTag: boolean;
}

/**
 * `llmOutputIds` must be ordered createdAt DESC (index 0 is the newest). The
 * active version is the latest human output's `editedFromLlmOutputId`, which
 * can be null or point to a version outside this list — both fall back to the
 * newest row.
 */
export const resolveActiveSummaryVersion = (
  llmOutputIds: string[],
  editedFromLlmOutputId: string | null | undefined,
): ResolvedActiveSummaryVersion => {
  const latestLlmOutputId = llmOutputIds[0];
  const activeLlmOutputId =
    editedFromLlmOutputId != null &&
    llmOutputIds.includes(editedFromLlmOutputId)
      ? editedFromLlmOutputId
      : null;

  return {
    latestLlmOutputId,
    activeLlmOutputId,
    defaultSelectedId: activeLlmOutputId ?? latestLlmOutputId,
    showLatestTag:
      activeLlmOutputId != null && activeLlmOutputId !== latestLlmOutputId,
  };
};
